import { TAppFormError } from "../../../types/TAppFormError";
import AlartMessages from "../../atoms/AlartMessages";
import Text from "../../atoms/form/Text";
import STTextFormRow from "../../../assets/styles/molecules/formRow/textFormRow.module.scss";
import validateFormRow from "../../../utils/form/validateFormRow";

type Props<T> = {
  defaultValue: string;
  title?: string;
  name: string;
  className: string;
  formKey: T;
  errors: TAppFormError<T>[];
  hundleOnChange: (value: string) => void;
  setErrors: (errors: TAppFormError<T>[]) => void;
  matchValue?: string;
  matchMessage?: string;
  required?: boolean;
  maxLength?: number;
  minLength?: number;
  pattern?: RegExp;
  patternText?: string;
  dataTestId?: string;
};

const TextFormRow = <T,>({
  defaultValue,
  title,
  name,
  className,
  formKey,
  errors,
  hundleOnChange,
  setErrors,
  matchValue,
  matchMessage,
  required = false,
  maxLength,
  minLength,
  pattern,
  patternText,
  dataTestId,
}: Props<T>) => {
  const hundleChange = (input: string) => {
    validateFormRow<T>({
      input,
      errors,
      setErrors,
      formKey,
      maxLength,
      minLength,
      pattern,
      patternText,
      required,
      matchValue,
      matchMessage,
    });
    hundleOnChange(input);
  };

  return (
    <div className={STTextFormRow.text_form_row}>
      {title && (
        <span>
          <small>{title}</small>
        </span>
      )}
      <div>
        <Text
          className={className}
          name={name}
          defaultValue={defaultValue}
          onChange={(input) => hundleChange(input)}
          dataTestId={dataTestId}
        ></Text>
        {AlartMessages<T>({
          title: name,
          errors: errors,
          keys: [formKey],
        })}
      </div>
    </div>
  );
};

export default TextFormRow;
